import React from 'react';
import PropTypes from 'prop-types';

export const CalendarTBD = ({fill = 'inherit', width = '30px', height = '69px'}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill={fill} width={width} height={height} viewBox="0 0 30 69">
      <path d="M30 3h-3.7l-1.2 2.2h2.7V10H2.2V5.2H7V8h2.2V0H7v3H0v25.2h30V3zm-2.2 23H2.2V12.2h25.5V26zM21 0h2.2v8H21V5.2h-9.9L12.3 3H21V0z" />
      <path d="M14.6 20.8c-1.2 0-2.1-.9-2.1-2.1 0-.9.5-1.6 1.3-2 .8-.3 1.7-.2 2.3.5s.8 1.5.5 2.3c-.3.7-1.1 1.3-2 1.3zm6.8 0c-1.2 0-2.1-.9-2.1-2.1 0-.9.5-1.6 1.3-2 .8-.3 1.7-.2 2.3.5s.8 1.5.5 2.3c-.4.7-1.2 1.3-2 1.3zm-13.5 0c-1.2 0-2.1-.9-2.1-2.1 0-.9.5-1.6 1.3-2 .8-.3 1.7-.2 2.3.5.6.6.8 1.5.5 2.3-.4.7-1.2 1.3-2 1.3z" />
    </svg>
  );
};

CalendarTBD.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};
